<script setup lang="ts">
defineProps<{ src: string, alt: string, noEnter?: boolean }>()
</script>

<template>
  <div
    class="w-full aspect-video bg-background border shadow-lg will-change-[transform,opacity] transform-gpu"
    :class="noEnter ? 'card-exit' : 'card-enter'"
  >
    <NuxtImg :src :alt class="size-full opacity-90 object-contain object-top" />
  </div>
</template>

<style scoped>
.card-enter {
  animation: card-enter linear both;
  animation-timeline: view();
  animation-range: cover cover;
}

@keyframes card-enter {
  0%,
  10% {
    scale: 0.9;
    opacity: 0;
    rotate: x -50deg;
  }
  30% {
    scale: 1;
    opacity: 1;
    rotate: x -10deg;
  }
  70% {
    scale: 1;
  }
  100% {
    scale: 0.9;
    rotate: x 10deg;
  }
}
</style>
